import React, { Suspense } from 'react'

import ReactDOM from 'react-dom/client'
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

import TravelsApp from './TravelsApp';

i18next
  .use(HttpApi)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    detection: {
      order: ['cookie', 'htmlTag', 'localStorage', 'path', 'subdomain'],
      caches: ['cookie', 'localStorage'],
    },
    backend: {
        loadPath: '/static/locales/translation.{{lng}}.json'
    },
  });

ReactDOM
  .createRoot(document.getElementById('travels-root') as HTMLElement)
  .render(
    <Suspense fallback="loading">
      <TravelsApp />
    </Suspense>
  )
